export default {
  hide: () => {},
  show: () => {},
};
